import {
  CRMConversationAutoReplyStatus,
  CRMConversationAutoResponseStatus,
} from "../../types";
import { formatVoiceConversationName } from "./formatVoiceConversationName";

export enum VoiceMessageType {
  text = "text",
}

type VoiceMessagePayload = {
  text: string;
  timestamp: string;
  type: VoiceMessageType;
};

export type VoiceMessageModel = {
  id: string;
  conv_id: string;
  name: string;
  type: "outgoing" | "incoming" | "info";
  msg_type: VoiceMessageType;
  from: string;
  msg_id: string;
  payload: VoiceMessagePayload;
  entity_id: string;
  read: boolean;
  status: string | null;
  attended_by?: string;
  auto_response: CRMConversationAutoResponseStatus;
  auto_reply: CRMConversationAutoReplyStatus | null;
};

export type VoiceMessageDto = {
  id: string;
  conv_id: string;
  type: "outgoing" | "incoming" | "info";
  msg_type: VoiceMessageType;
  inserted_at: string;
  from: string;
  msg_id: string;
  payload: string;
  entity_id: string;
  read: boolean;
  status: string | null;
  auto_response: number;
  attended_by: string;
  auto_reply: CRMConversationAutoReplyStatus | null;
};

export const transformVoiceMessageDtoToModel = (
  dto: VoiceMessageDto
): VoiceMessageModel => {
  return {
    ...dto,
    name: formatVoiceConversationName(dto.conv_id),
    payload: {
      text: dto.payload,
      timestamp: dto.inserted_at,
      type: dto.msg_type,
    },
  };
};
